<template>
  <v-row justify="center" v-if="userRole !== 'registrar_sign'">
    <v-dialog v-model="dialog" persistent max-width="900px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" rounded large v-on="on">
          <v-img src="@/assets/add-icon.svg" class="mr-2" />
          <span class="text-capitalize mr-1">Новая</span><span class="text-lowercase">запись</span>
        </v-btn>
      </template>
      <RegistrarForm @close-form="closeHandler" :userRole="userRole" />
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'Registration',
  data: () => ({
    dialog: false
  }),
  components: {
    RegistrarForm: () => import('../components/registration/RegistrarForm')
  },
  computed: {
    userRole() {
      return this.$store.state.user.role
    }
  },
  methods: {
    closeHandler(value) {
      this.dialog = value
    }
  }
}
</script>
